exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root,body,html{margin:0;padding:0}body,h1,h2,h3,h4,h5,h6{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Ubuntu,Roboto,Helvetica Neue,Arial,sans-serif}h1,h2,h3,h4,h5,h6{font-weight:600}em{color:tomato;font:inherit;text-decoration:inherit}html{font-size:100%;line-height:1.4}@media (min-width:60em){html{font-size:100%}}@media (min-width:75em){html{font-size:100%}}.hidden{display:none}", ""]);

// exports
